/* eslint-disable camelcase */
import React from 'react'

import Image from 'components/Image'
import logUtil from 'utils/log'
import getDefaultSwatchImageProductUtil from 'modules/product/utils/get-default-swatch-image'

export default function ProductSwatchColorIcon (props) {
  const {
    colorIconUrl,
    shouldLazyLoad,
    image
  } = props

  const [shouldUseDefaultImage, setShouldUseDefaultImage] = React.useState()
  const [error, setError] = React.useState()
  const defaultImage = getDefaultSwatchImageProductUtil(image)
  logUtil('ProductSwatchColorIcon').debug('[start] props=', props)

  const handleError = (error) => {
    if (shouldUseDefaultImage) {
      setError(error)
      return
    }
    setShouldUseDefaultImage(true)
  }

  if (error) {
    logUtil('ProductSwatchColorIcon').debug('[noop] error=', error)
    return <></>
  }

  return (
    <div className='product-swatch-color-icon'>
      <Image
        src={shouldUseDefaultImage ? defaultImage : colorIconUrl}
        shouldLazyLoad={shouldLazyLoad}
        onError={handleError}
      />
    </div>
  )
}
